import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  getRevenueReports,
  getCallLogsReports,
  getEmployeeAnalysis,
  getLoyaltyReports,
  getMenuReports,
  getOrderReports,
  getReservationReports,
  getTableReports,
  getOverviewReport,
  getOfferReports
} from '@/api/new-api/dashboard/dashboard'

export const fetchRevenueReports = createAsyncThunk(
  'dashboard/fetchRevenueReports',
  async ({ restaurant_id, params, requestMeta }, { rejectWithValue }) => {
    try {
      const res = await getRevenueReports(restaurant_id, params)
      if (res.status === 'success') {
        return {
          data: res.data,
          requestMeta: requestMeta || null
        }
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchEmployeeAnalysis = createAsyncThunk(
  'dashboard/fetchEmployeeAnalysis',
  async ({ restaurant_id, params }, { rejectWithValue }) => {
    try {
      const res = await getEmployeeAnalysis(restaurant_id, params)
      if (res.status === 'success') {
        return res.data
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchMenuReports = createAsyncThunk(
  'dashboard/fetchMenuReports',
  async ({ restaurant_id, params }, { rejectWithValue }) => {
    try {
      const res = await getMenuReports(restaurant_id, params)
      if (res.status === 'success') {
        return res.data
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchCallLogsReports = createAsyncThunk(
  'dashboard/fetchCallLogsReports',
  async ({ restaurant_id, params, requestMeta }, { rejectWithValue }) => {
    try {
      const res = await getCallLogsReports(restaurant_id, params)
      if (res.status === 'success') {
        return {
          data: res.data,
          requestMeta: requestMeta || null
        }
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchLoyaltyReports = createAsyncThunk(
  'dashboard/fetchLoyaltyReports',
  async ({ restaurant_id, params, requestMeta }, { rejectWithValue }) => {
    try {
      const res = await getLoyaltyReports(restaurant_id, params)
      if (res.status === 'success') {
        return {
          data: res.data,
          requestMeta: requestMeta || null
        }
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchTableReports = createAsyncThunk(
  'dashboard/fetchTableReports',
  async ({ restaurant_id, params, requestMeta }, { rejectWithValue }) => {
    try {
      const res = await getTableReports(restaurant_id, params)
      if (res.status === 'success') {
        return {
          data: res.data,
          requestMeta: requestMeta || null
        }
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchReservationReports = createAsyncThunk(
  'dashboard/fetchReservationReports',
  async ({ restaurant_id, params, requestMeta }, { rejectWithValue }) => {
    try {
      const res = await getReservationReports(restaurant_id, params)
      if (res.status === 'success') {
        return {
          data: res.data,
          requestMeta: requestMeta || null
        }
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchOrderReports = createAsyncThunk(
  'dashboard/fetchOrderReports',
  async ({ restaurant_id, params, requestMeta }, { rejectWithValue }) => {
    try {
      const res = await getOrderReports(restaurant_id, params)
      if (res.status === 'success') {
        return {
          data: res.data,
          requestMeta: requestMeta || null
        }
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchOverviewReport = createAsyncThunk(
  'dashboard/fetchOverviewReport',
  async ({ restaurant_id, params }, { rejectWithValue }) => {
    try {
      const res = await getOverviewReport(restaurant_id, params)
      if (res.status === 'success') {
        return res.data
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchOfferReports = createAsyncThunk(
  'dashboard/fetchOfferReports',
  async ({ restaurant_id, params, requestMeta }, { rejectWithValue }) => {
    try {
      const res = await getOfferReports(restaurant_id, params)
      if (res.status === 'success') {
        return {
          data: res.data,
          requestMeta: requestMeta || null
        }
      }
      return rejectWithValue(res.message)
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)


// Initial State

const initialState = {
  revenueReports: null,
  revenueLoading: {
    initial: false,
    comparison: false,
    totalRevenue: false,
    yearlyComparison: false
  },
  employeeAnalysis: null,
  employeeAnalysisLoading: false,
  menuReports: null,
  menuReportsLoading: false,
  callLogsReports: null,
  callLogsLoading: {
    initial: false,
    comparison: false,
    totalCall: false
  },
  loyaltyReports: null,
  loyaltyLoading: {
    initial: false,
    comparison: false,
    totalValue: false,
    yearlyComparison: false
  },
  tableReports: null,
  tableLoading: {
    initial: false,
    comparison: false,
    totalRevenue: false,
    yearlyComparison: false
  },
  reservationReports: null,
  reservationLoading: {
    initial: false,
    comparison: false,
    totalReservation: false,
    yearlyComparison: false
  },
  orderReports: null,
  orderLoading: {
    initial: false,
    comparison: false,
    totalOrders: false,
    yearlyComparison: false
  },
  offerReports: null,
  offerLoading: {
    initial: false,
    comparison: false,
    totalValue: false,
    yearlyComparison: false
  },
  overviewReport: null,
  overviewLoading: false,
  getLoading: false,
  error: null
}

// slice
const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Revenue Reports
      .addCase(fetchRevenueReports.pending, (state, action) => {
        const requestMeta = action?.meta?.arg?.requestMeta

        if (requestMeta?.mode === 'initial') {
          state.revenueLoading.initial = true
        } else if (requestMeta?.chart && state.revenueLoading[requestMeta.chart] !== undefined) {
          state.revenueLoading[requestMeta.chart] = true
        } else {
          state.revenueLoading.initial = true
        }

        state.getLoading = true
        state.error = null
      })
      .addCase(fetchRevenueReports.fulfilled, (state, action) => {
        const { data, requestMeta } = action.payload || {}

        state.getLoading = false

        if (requestMeta?.mode === 'initial' || !state.revenueReports) {
          state.revenueReports = data
          state.revenueLoading.initial = false
          state.revenueLoading.comparison = false
          state.revenueLoading.totalRevenue = false
          state.revenueLoading.yearlyComparison = false
          return
        }

        if (requestMeta?.chart === 'comparison') {
          state.revenueReports = {
            ...state.revenueReports,
            stats: data?.stats || state.revenueReports?.stats,
            charts: {
              ...state.revenueReports?.charts,
              comparison: {
                ...state.revenueReports?.charts?.comparison,
                ...data?.charts?.comparison
              }
            }
          }
          state.revenueLoading.comparison = false
          return
        }

        if (requestMeta?.chart === 'totalRevenue') {
          state.revenueReports = {
            ...state.revenueReports,
            stats: data?.stats || state.revenueReports?.stats,
            charts: {
              ...state.revenueReports?.charts,
              totalRevenue: {
                ...state.revenueReports?.charts?.totalRevenue,
                ...data?.charts?.totalRevenue
              }
            }
          }
          state.revenueLoading.totalRevenue = false
          return
        }

        if (requestMeta?.chart === 'yearlyComparison') {
          state.revenueReports = {
            ...state.revenueReports,
            stats: data?.stats || state.revenueReports?.stats,
            charts: {
              ...state.revenueReports?.charts,
              yearlyComparison: {
                ...state.revenueReports?.charts?.yearlyComparison,
                ...data?.charts?.yearlyComparison
              }
            }
          }
          state.revenueLoading.yearlyComparison = false
          return
        }

        state.revenueReports = data
      })
      .addCase(fetchRevenueReports.rejected, (state, action) => {
        state.getLoading = false
        state.revenueLoading.initial = false
        state.revenueLoading.comparison = false
        state.revenueLoading.totalRevenue = false
        state.revenueLoading.yearlyComparison = false
        state.error = action.payload || 'Failed to fetch revenue reports'
      })
      // Employee Analysis
      .addCase(fetchEmployeeAnalysis.pending, state => {
        state.employeeAnalysisLoading = true
        state.getLoading = true
        state.error = null
      })
      .addCase(fetchEmployeeAnalysis.fulfilled, (state, action) => {
        state.employeeAnalysisLoading = false
        state.getLoading = false
        state.employeeAnalysis = action.payload
      })
      .addCase(fetchEmployeeAnalysis.rejected, (state, action) => {
        state.employeeAnalysisLoading = false
        state.getLoading = false
        state.error = action.payload || 'Failed to fetch employee analysis'
      })
      // Menu Reports
      .addCase(fetchMenuReports.pending, state => {
        state.menuReportsLoading = true
        state.getLoading = true
        state.error = null
      })
      .addCase(fetchMenuReports.fulfilled, (state, action) => {
        state.menuReportsLoading = false
        state.getLoading = false
        state.menuReports = action.payload
      })
      .addCase(fetchMenuReports.rejected, (state, action) => {
        state.menuReportsLoading = false
        state.getLoading = false
        state.error = action.payload || 'Failed to fetch menu reports'
      })
      // Call Logs Reports
      .addCase(fetchCallLogsReports.pending, (state, action) => {
        const requestMeta = action?.meta?.arg?.requestMeta

        if (requestMeta?.mode === 'initial') {
          state.callLogsLoading.initial = true
        } else if (requestMeta?.chart && state.callLogsLoading[requestMeta.chart] !== undefined) {
          state.callLogsLoading[requestMeta.chart] = true
        } else {
          state.callLogsLoading.initial = true
        }

        state.getLoading = true
        state.error = null
      })
      .addCase(fetchCallLogsReports.fulfilled, (state, action) => {
        const { data, requestMeta } = action.payload || {}

        state.getLoading = false

        if (requestMeta?.mode === 'initial' || !state.callLogsReports) {
          state.callLogsReports = data
          state.callLogsLoading.initial = false
          state.callLogsLoading.comparison = false
          state.callLogsLoading.totalCall = false
          return
        }

        if (requestMeta?.chart === 'comparison') {
          state.callLogsReports = {
            ...state.callLogsReports,
            stats: data?.stats || state.callLogsReports?.stats,
            charts: {
              ...state.callLogsReports?.charts,
              comparison: {
                ...state.callLogsReports?.charts?.comparison,
                ...data?.charts?.comparison
              }
            }
          }
          state.callLogsLoading.comparison = false
          return
        }

        if (requestMeta?.chart === 'totalCall') {
          state.callLogsReports = {
            ...state.callLogsReports,
            stats: data?.stats || state.callLogsReports?.stats,
            charts: {
              ...state.callLogsReports?.charts,
              totalCall: {
                ...state.callLogsReports?.charts?.totalCall,
                ...data?.charts?.totalCall
              }
            }
          }
          state.callLogsLoading.totalCall = false
          return
        }

        state.callLogsReports = data
      })
      .addCase(fetchCallLogsReports.rejected, (state, action) => {
        state.getLoading = false
        state.callLogsLoading.initial = false
        state.callLogsLoading.comparison = false
        state.callLogsLoading.totalCall = false
        state.error = action.payload || 'Failed to fetch call logs reports'
      })
      // Loyalty Reports
      .addCase(fetchLoyaltyReports.pending, (state, action) => {
        const requestMeta = action?.meta?.arg?.requestMeta

        if (requestMeta?.mode === 'initial') {
          state.loyaltyLoading.initial = true
        } else if (requestMeta?.chart && state.loyaltyLoading[requestMeta.chart] !== undefined) {
          state.loyaltyLoading[requestMeta.chart] = true
        } else {
          state.loyaltyLoading.initial = true
        }

        state.getLoading = true
        state.error = null
      })
      .addCase(fetchLoyaltyReports.fulfilled, (state, action) => {
        const { data, requestMeta } = action.payload || {}

        state.getLoading = false

        if (requestMeta?.mode === 'initial' || !state.loyaltyReports) {
          state.loyaltyReports = data
          state.loyaltyLoading.initial = false
          state.loyaltyLoading.comparison = false
          state.loyaltyLoading.totalValue = false
          state.loyaltyLoading.yearlyComparison = false
          return
        }

        if (requestMeta?.chart === 'comparison') {
          state.loyaltyReports = {
            ...state.loyaltyReports,
            stats: data?.stats || state.loyaltyReports?.stats,
            charts: {
              ...state.loyaltyReports?.charts,
              comparison: {
                ...state.loyaltyReports?.charts?.comparison,
                ...data?.charts?.comparison
              }
            }
          }
          state.loyaltyLoading.comparison = false
          return
        }

        if (requestMeta?.chart === 'totalValue') {
          state.loyaltyReports = {
            ...state.loyaltyReports,
            stats: data?.stats || state.loyaltyReports?.stats,
            charts: {
              ...state.loyaltyReports?.charts,
              totalValue: {
                ...state.loyaltyReports?.charts?.totalValue,
                ...data?.charts?.totalValue
              }
            }
          }
          state.loyaltyLoading.totalValue = false
          return
        }

        if (requestMeta?.chart === 'yearlyComparison') {
          state.loyaltyReports = {
            ...state.loyaltyReports,
            stats: data?.stats || state.loyaltyReports?.stats,
            charts: {
              ...state.loyaltyReports?.charts,
              yearlyComparison: {
                ...state.loyaltyReports?.charts?.yearlyComparison,
                ...data?.charts?.yearlyComparison
              }
            }
          }
          state.loyaltyLoading.yearlyComparison = false
          return
        }

        state.loyaltyReports = data
      })
      .addCase(fetchLoyaltyReports.rejected, (state, action) => {
        state.getLoading = false
        state.loyaltyLoading.initial = false
        state.loyaltyLoading.comparison = false
        state.loyaltyLoading.totalValue = false
        state.loyaltyLoading.yearlyComparison = false
        state.error = action.payload || 'Failed to fetch loyalty reports'
      })
      // Table Reports
      .addCase(fetchTableReports.pending, (state, action) => {
        const requestMeta = action?.meta?.arg?.requestMeta

        if (requestMeta?.mode === 'initial') {
          state.tableLoading.initial = true
        } else if (requestMeta?.chart && state.tableLoading[requestMeta.chart] !== undefined) {
          state.tableLoading[requestMeta.chart] = true
        } else {
          state.tableLoading.initial = true
        }

        state.getLoading = true
        state.error = null
      })
      .addCase(fetchTableReports.fulfilled, (state, action) => {
        const { data, requestMeta } = action.payload || {}

        state.getLoading = false

        if (requestMeta?.mode === 'initial' || !state.tableReports) {
          state.tableReports = data
          state.tableLoading.initial = false
          state.tableLoading.comparison = false
          state.tableLoading.totalRevenue = false
          state.tableLoading.yearlyComparison = false
          return
        }

        if (requestMeta?.chart === 'comparison') {
          state.tableReports = {
            ...state.tableReports,
            stats: data?.stats || state.tableReports?.stats,
            charts: {
              ...state.tableReports?.charts,
              comparison: {
                ...state.tableReports?.charts?.comparison,
                ...data?.charts?.comparison
              }
            }
          }
          state.tableLoading.comparison = false
          return
        }

        if (requestMeta?.chart === 'totalRevenue') {
          state.tableReports = {
            ...state.tableReports,
            stats: data?.stats || state.tableReports?.stats,
            charts: {
              ...state.tableReports?.charts,
              totalRevenue: {
                ...state.tableReports?.charts?.totalRevenue,
                ...data?.charts?.totalRevenue
              }
            }
          }
          state.tableLoading.totalRevenue = false
          return
        }

        if (requestMeta?.chart === 'yearlyComparison') {
          state.tableReports = {
            ...state.tableReports,
            stats: data?.stats || state.tableReports?.stats,
            charts: {
              ...state.tableReports?.charts,
              yearlyComparison: {
                ...state.tableReports?.charts?.yearlyComparison,
                ...data?.charts?.yearlyComparison
              }
            }
          }
          state.tableLoading.yearlyComparison = false
          return
        }

        state.tableReports = data
      })
      .addCase(fetchTableReports.rejected, (state, action) => {
        state.getLoading = false
        state.tableLoading.initial = false
        state.tableLoading.comparison = false
        state.tableLoading.totalRevenue = false
        state.tableLoading.yearlyComparison = false
        state.error = action.payload || 'Failed to fetch table reports'
      })
      // Reservation Reports
      .addCase(fetchReservationReports.pending, (state, action) => {
        const requestMeta = action?.meta?.arg?.requestMeta

        if (requestMeta?.mode === 'initial') {
          state.reservationLoading.initial = true
        } else if (requestMeta?.chart && state.reservationLoading[requestMeta.chart] !== undefined) {
          state.reservationLoading[requestMeta.chart] = true
        } else {
          state.reservationLoading.initial = true
        }

        state.getLoading = true
        state.error = null
      })
      .addCase(fetchReservationReports.fulfilled, (state, action) => {
        const { data, requestMeta } = action.payload || {}

        state.getLoading = false

        if (requestMeta?.mode === 'initial' || !state.reservationReports) {
          state.reservationReports = data
          state.reservationLoading.initial = false
          state.reservationLoading.comparison = false
          state.reservationLoading.totalReservation = false
          state.reservationLoading.yearlyComparison = false
          return
        }

        if (requestMeta?.chart === 'comparison') {
          state.reservationReports = {
            ...state.reservationReports,
            stats: data?.stats || state.reservationReports?.stats,
            charts: {
              ...state.reservationReports?.charts,
              comparison: {
                ...state.reservationReports?.charts?.comparison,
                ...data?.charts?.comparison
              }
            }
          }
          state.reservationLoading.comparison = false
          return
        }

        if (requestMeta?.chart === 'totalReservation') {
          state.reservationReports = {
            ...state.reservationReports,
            stats: data?.stats || state.reservationReports?.stats,
            charts: {
              ...state.reservationReports?.charts,
              totalReservation: {
                ...state.reservationReports?.charts?.totalReservation,
                ...data?.charts?.totalReservation
              }
            }
          }
          state.reservationLoading.totalReservation = false
          return
        }

        if (requestMeta?.chart === 'yearlyComparison') {
          state.reservationReports = {
            ...state.reservationReports,
            stats: data?.stats || state.reservationReports?.stats,
            charts: {
              ...state.reservationReports?.charts,
              yearlyComparison: {
                ...state.reservationReports?.charts?.yearlyComparison,
                ...data?.charts?.yearlyComparison
              }
            }
          }
          state.reservationLoading.yearlyComparison = false
          return
        }

        state.reservationReports = data
      })
      .addCase(fetchReservationReports.rejected, (state, action) => {
        state.getLoading = false
        state.reservationLoading.initial = false
        state.reservationLoading.comparison = false
        state.reservationLoading.totalReservation = false
        state.reservationLoading.yearlyComparison = false
        state.error = action.payload || 'Failed to fetch reservation reports'
      })
      // Order Reports
      .addCase(fetchOrderReports.pending, (state, action) => {
        const requestMeta = action?.meta?.arg?.requestMeta

        if (requestMeta?.mode === 'initial') {
          state.orderLoading.initial = true
        } else if (requestMeta?.chart && state.orderLoading[requestMeta.chart] !== undefined) {
          state.orderLoading[requestMeta.chart] = true
        } else {
          state.orderLoading.initial = true
        }

        state.getLoading = true
        state.error = null
      })
      .addCase(fetchOrderReports.fulfilled, (state, action) => {
        const { data, requestMeta } = action.payload || {}

        state.getLoading = false

        if (requestMeta?.mode === 'initial' || !state.orderReports) {
          state.orderReports = data
          state.orderLoading.initial = false
          state.orderLoading.comparison = false
          state.orderLoading.totalOrders = false
          state.orderLoading.yearlyComparison = false
          return
        }

        if (requestMeta?.chart === 'comparison') {
          state.orderReports = {
            ...state.orderReports,
            stats: data?.stats || state.orderReports?.stats,
            charts: {
              ...state.orderReports?.charts,
              comparison: {
                ...state.orderReports?.charts?.comparison,
                ...data?.charts?.comparison
              }
            }
          }
          state.orderLoading.comparison = false
          return
        }

        if (requestMeta?.chart === 'totalOrders') {
          state.orderReports = {
            ...state.orderReports,
            stats: data?.stats || state.orderReports?.stats,
            charts: {
              ...state.orderReports?.charts,
              totalOrders: {
                ...state.orderReports?.charts?.totalOrders,
                ...data?.charts?.totalOrders
              }
            }
          }
          state.orderLoading.totalOrders = false
          return
        }

        if (requestMeta?.chart === 'yearlyComparison') {
          state.orderReports = {
            ...state.orderReports,
            stats: data?.stats || state.orderReports?.stats,
            charts: {
              ...state.orderReports?.charts,
              yearlyComparison: {
                ...state.orderReports?.charts?.yearlyComparison,
                ...data?.charts?.yearlyComparison
              }
            }
          }
          state.orderLoading.yearlyComparison = false
          return
        }

        state.orderReports = data
      })
      .addCase(fetchOrderReports.rejected, (state, action) => {
        state.getLoading = false
        state.orderLoading.initial = false
        state.orderLoading.comparison = false
        state.orderLoading.totalOrders = false
        state.orderLoading.yearlyComparison = false
        state.error = action.payload || 'Failed to fetch order reports'
      })
      // Offer Reports
      .addCase(fetchOfferReports.pending, (state, action) => {
        const requestMeta = action?.meta?.arg?.requestMeta

        if (requestMeta?.mode === 'initial') {
          state.offerLoading.initial = true
        } else if (requestMeta?.chart && state.offerLoading[requestMeta.chart] !== undefined) {
          state.offerLoading[requestMeta.chart] = true
        } else {
          state.offerLoading.initial = true
        }

        state.getLoading = true
        state.error = null
      })
      .addCase(fetchOfferReports.fulfilled, (state, action) => {
        const { data, requestMeta } = action.payload || {}

        state.getLoading = false

        if (requestMeta?.mode === 'initial' || !state.offerReports) {
          state.offerReports = data
          state.offerLoading.initial = false
          state.offerLoading.comparison = false
          state.offerLoading.totalValue = false
          state.offerLoading.yearlyComparison = false
          return
        }

        if (requestMeta?.chart === 'comparison') {
          state.offerReports = {
            ...state.offerReports,
            stats: data?.stats || state.offerReports?.stats,
            charts: {
              ...state.offerReports?.charts,
              comparison: {
                ...state.offerReports?.charts?.comparison,
                ...data?.charts?.comparison
              }
            }
          }
          state.offerLoading.comparison = false
          return
        }

        if (requestMeta?.chart === 'totalValue') {
          state.offerReports = {
            ...state.offerReports,
            stats: data?.stats || state.offerReports?.stats,
            charts: {
              ...state.offerReports?.charts,
              totalValue: {
                ...state.offerReports?.charts?.totalValue,
                ...data?.charts?.totalValue
              }
            }
          }
          state.offerLoading.totalValue = false
          return
        }

        if (requestMeta?.chart === 'yearlyComparison') {
          state.offerReports = {
            ...state.offerReports,
            stats: data?.stats || state.offerReports?.stats,
            charts: {
              ...state.offerReports?.charts,
              yearlyComparison: {
                ...state.offerReports?.charts?.yearlyComparison,
                ...data?.charts?.yearlyComparison
              }
            }
          }
          state.offerLoading.yearlyComparison = false
          return
        }

        state.offerReports = data
      })
      .addCase(fetchOfferReports.rejected, (state, action) => {
        state.getLoading = false
        state.offerLoading.initial = false
        state.offerLoading.comparison = false
        state.offerLoading.totalValue = false
        state.offerLoading.yearlyComparison = false
        state.error = action.payload || 'Failed to fetch offer reports'
      })
      // Overview Report
      .addCase(fetchOverviewReport.pending, state => {
        state.overviewLoading = true
        state.error = null
      })
      .addCase(fetchOverviewReport.fulfilled, (state, action) => {
        state.overviewLoading = false
        state.overviewReport = action.payload
      })
      .addCase(fetchOverviewReport.rejected, (state, action) => {
        state.overviewLoading = false
        state.error = action.payload || 'Failed to fetch overview report'
      })
  }
})

export default dashboardSlice.reducer
